var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$store.state.isNavBarOff)?_c('HeaderNav',{attrs:{"auth":true}}):_vm._e(),_c('div',{staticClass:"test"},[(_vm.$store.state.isNavBarOff)?_c('SideBarDesktop'):_vm._e(),_c('div',{staticClass:"wrapper-lc"},[_c('router-view',{attrs:{"name":"LcMenu"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }